<!--工作室资讯-->
<template>
    <div class="menu-container">
        <div @click="changeItem('1')" :class="activeItem==='1'?'menu-item menu-active':'menu-item'">概览</div>
        <div @click="changeItem('2')" :class="activeItem==='2'?'menu-item menu-active':'menu-item'">工作室查询</div>
        <div @click="changeItem('3')" :class="activeItem==='3'?'menu-item menu-active':'menu-item'">工作室成果</div>
        <div @click="changeItem('4')" :class="activeItem==='4'?'menu-item menu-active':'menu-item'">工作室资讯</div>
    </div>
</template>

<script>

export default {
    name:'studioMenu',
    components:{},
    props:{
        itemNum:{
            type: String,
            default:"1"
        },
        studioNature:{
            type: String,
            default:"2"
        },
    },
    watch:{
        itemNum(newValue,oldValue){
            this.activeItem = newValue;
        },
    },
    mounted() {},
    data() {
        return {
            activeItem:"1",
        }
    },
    methods: {
        changeItem(item){
            this.activeItem = item;
            this.$emit('change-item', item );
        },
    }
}

</script>

<style scoped>
.menu-container{

    /*width: 100%;*/
    height: calc(100vh - 120px);
    background: #dfe4f7;
    padding-top: 15px;
    padding-bottom: 15px;
    border-radius: 10px;
    width: 180px!important;
    position: fixed;
    top: 80px;
    z-index: 999;
}
.menu-item{
    width: 100%;
    height: 50px;
    line-height: 50px;
    text-indent: 15px;
    font-size: 15px;
    color: #707070;
    cursor: pointer;
}
.menu-active{
    background: #3b62f8;
    color: #fff;
    //font-weight: bold;
}
</style>